import { useCallback } from 'react';
import { API_ENDPOINTS } from '../config/api/apiCall';
import { ReturnIndentCRUD } from '../services/returnIndentServise';

const useReturnIndentCRUD = (callMessage) => {
    const processIndent = useCallback(async (selectedMode, editIssueIndentID, requestBody) => {
        try {
            const apiEndpoint = selectedMode === 0
                ? API_ENDPOINTS.RETURN_INDENT_CRUD_PROCESS
                : API_ENDPOINTS.RETURN_INDENT_CRUD_PROCESS;

            const successMessage = selectedMode === 0
                ? (editIssueIndentID !== 0 
                    ? 'Return indent updated Successfully' 
                    : 'New Return indent Created Successfully')
                : 'Return indent Approved Successfully';

            // Await the API response
            const data = await ReturnIndentCRUD(apiEndpoint, requestBody);
            
            if (data?.length > 0) {
                callMessage('info', successMessage, 'info');
            } else {
                callMessage('error', 'No data received from API', 'Error');
            }
        } catch (error) {
            callMessage('error', error.message || 'An unexpected error occurred', 'Error');
        }
    }, [callMessage]);

    return { processIndent };
};

export default useReturnIndentCRUD;

